/**
 * Every `<category>HarmCaused` text is four labelled lines — "Reported:",
 * "Directly caused:", "Indirectly caused:", "Inferred additional harm:" — and
 * most of them say "N/A" (about 55,000 of the 90,000 lines on the Arcola
 * mirror, 11 Oct 2026). Drop a labelled line whose value is N/A or empty;
 * keep everything else, including terse values like "Reported: No".
 */
const NOT_APPLICABLE_LINE = /^\s*[^:\n]{1,40}:\s*(?:n\/?a\.?)?\s*$/i;

export function withoutNotApplicableLines(text: string): string {
  return text
    .split('\n')
    .filter((line) => line.trim() !== '' && !NOT_APPLICABLE_LINE.test(line))
    .join('\n');
}
